import { Checkbox, Stack } from '@mantine/core';
import { BasicFieldInputs } from '../components/BasicFieldInputs';
import { toInputName } from '../utils/toInputName';
import { useIntl } from 'react-intl';

export const MapField = ({
  field,
  setField,
}: {
  field: any;
  setField: (field: any) => void;
}) => {
  const intl = useIntl();
  return (
    <Stack gap="md">
      <BasicFieldInputs
        fields={['label', 'description']}
        fieldValues={field}
        requiredFields={['label']}
        onChange={(key, value) =>
          setField({
            ...field,
            [key]: value,
            ...(key === 'name' ? { name: toInputName(value) } : {}),
          })
        }
      />

      <Checkbox
        label={intl.formatMessage({ id: 'disabled' })}
        value={field.isDisabled}
        onChange={(event) =>
          setField({ ...field, isDisabled: event.currentTarget.checked })
        }
      />
    </Stack>
  );
};
